import { baseApi } from '../baseApi';
import { gql } from 'graphql-request';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder: any) => ({
    logout: builder.mutation({
      query: () => ({
        body: gql`
          mutation Logout {
            logout {
              success
            }
          }
        `,
      }),
      transformResponse: (res: any): any => res.logout,
    }),
    removeCookie: builder.mutation({
      query: () => ({
        body: gql`
          mutation removeCookie {
            removeCookie {
              success
            }
          }
        `,
      }),
      transformResponse: (res: any): any => res.logout,
    }),
  }),
  overrideExisting: false,
});
export const { useLogoutMutation, useRemoveCookieMutation } = authApi;
